import { useState, useEffect } from 'react';
import { IBlock } from '../shared/interfaces/IBlock';

const useAIReply = (
  header: string | null,
  rating: number | null,
  blocks?: IBlock[],
  text?: string | null,
  textCompanyPros?: string | null,
  textCompanyCons?: string | null,
  mandatoryAssessments?: { rating: number; original_rating: number; title: string | null }[],
  optionalAssessments?: { rating: number; original_rating: number; title: string | null }[]
) => {
  const [aiResponse, setAiResponse] = useState<string>('');

  useEffect(() => {
    let responses = '';
    if (!text && blocks && blocks.length > 0) {
      responses = blocks
        .map((block, index) => {
          const ratingInfo = block.rating
            ? `${block.rating} out of 5 stars.`
            : 'No rating provided.';
          return `${block.title}, ${block.text}: ${ratingInfo}`;
        })
        .join(' ');

      if (mandatoryAssessments && mandatoryAssessments.length > 0) {
        const mandatoryResponses = mandatoryAssessments
          .map((assessment) => {
            return `${assessment.title}: ${assessment.rating} out of 5 stars.`;
          })
          .join(' ');
        responses += ' ' + mandatoryResponses;
      }
    }

    const additionalInfo = [];
    if (textCompanyPros) additionalInfo.push(`Pros: ${textCompanyPros}`);
    if (textCompanyCons) additionalInfo.push(`Cons: ${textCompanyCons}`);
    if (mandatoryAssessments && mandatoryAssessments.length > 0) {
      additionalInfo.push(
        `Mandatory assessments: ${mandatoryAssessments
          .map((a) => `${a.title}: ${a.rating}`)
          .join(', ')}`
      );
    }
    if (optionalAssessments && optionalAssessments.length > 0) {
      additionalInfo.push(
        `Optional assessments: ${optionalAssessments
          .map((a) => `${a.title}: ${a.rating}`)
          .join(', ')}`
      );
    }

    const combinedResponse = `${header ? header + ' ' : ''}${responses} ${additionalInfo.join(
      ' '
    )}`;
    setAiResponse(combinedResponse.trim());
  }, [
    header,
    blocks,
    text,
    textCompanyPros,
    textCompanyCons,
    mandatoryAssessments,
    optionalAssessments,
  ]);

  return aiResponse;
};

export default useAIReply;
